module.exports = __webpack_public_path__ + "static/media/history_11.55cbc8cd.jpg";